import React from "react";
import { useLocale } from "../../hooks";
import { useCombinedTranslations } from "./combinedTranslations";

const FormattedMessage: React.FC<{ id: string }> = ({ id }) => {
  const {
    data: { locale },
  } = useLocale();
  const translations = useCombinedTranslations();
  return <>{translations[locale][id] || id}</>;
};

export default FormattedMessage;
